import { render, staticRenderFns } from "./itemCompareRow.vue?vue&type=template&id=368be49f&scoped=true&"
import script from "./itemCompareRow.vue?vue&type=script&lang=js&"
export * from "./itemCompareRow.vue?vue&type=script&lang=js&"
import style0 from "./itemCompareRow.vue?vue&type=style&index=0&id=368be49f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368be49f",
  null
  
)

export default component.exports